import type { ReactElement } from 'react';
import { Navigate, Outlet, useLocation } from 'react-router';
import { useAuthStore } from '@/entities/user';

/**
 * 보호 라우트 가드 — 비로그인 접근을 로그인 화면으로 보낸다.
 *
 * 세션 만료(자동 재발급 실패)로 스토어가 비워지면 이 가드가 즉시 발동한다.
 * 원래 목적지는 쿼리까지 state 로 넘긴다 — 결제 페이지(?orderId=)처럼 쿼리가 곧 대상인 화면이 있다.
 */
export const RequireAuth = (): ReactElement => {
  const isAuthenticated = useAuthStore((state) => state.isAuthenticated);
  const location = useLocation();

  if (!isAuthenticated) {
    return (
      <Navigate to="/sign-in" replace state={{ from: `${location.pathname}${location.search}` }} />
    );
  }

  return <Outlet />;
};
